/*
 * Module for handling of ajax navigation links
 */
rs.module("content/system/configuration/correspondencepackets/edit",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {
        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, columnIds, grid, ajaxUrl, defaultTemplatePackageLinkKey) {
            var includedCorrespondencesForm = $.js(jsSelectors.includedCorrespondencesForm, { required: false });
            var templateIdSelect = includedCorrespondencesForm.js(jsSelectors.templateIdSelect, { required: false });
            var templateIdSelectHelper = selectHelper.getHelper(templateIdSelect, { required: false });
            var descriptionTextArea = includedCorrespondencesForm.js(jsSelectors.descriptionTextArea, { required: false });
            var positionOrderInput = includedCorrespondencesForm.js(jsSelectors.positionOrderInput, { required: false });
            var addCorrespondenceLink = includedCorrespondencesForm.js(jsSelectors.addCorrespondenceLink, { required: false });
            var correspondenceUpdateToken = includedCorrespondencesForm.js(jsSelectors.correspondenceUpdateToken, { required: false });
            var cancelCorrespondenceButton = includedCorrespondencesForm.js(jsSelectors.cancelCorrespondenceButton, { required: false });
            var templatePackageLinkKey = includedCorrespondencesForm.js(jsSelectors.templatePackageLinkKey, { required: false });

            if (grid) {
                addCorrespondenceLink.on("click", addCorrespondenceClicked);
                cancelCorrespondenceButton.on("click", cancelCorrespondenceClicked);

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrl,
                            {
                                templatePackageKey: rows[0][columnIds.templatePackageKey],
                                templatePackageLinkKey: rows[0][columnIds.templatePackageLinkKey]
                            },

                            function (data) {
                                templateIdSelectHelper.setValue(data.templateId);
                                templateIdSelect.clearErrors();
                                descriptionTextArea.val(data.packageLinkDescription).clearErrors();
                                positionOrderInput.val(data.positionOrder).clearErrors();

                                templatePackageLinkKey.val(data.templatePackageLinkKey);
                                correspondenceUpdateToken.val(data.updateToken);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear the current values and grid selection when the add correspondence button is clicked
                function addCorrespondenceClicked() {
                    eventBanner.removeAllMessages();

                    grid.selectedValues = null;

                    templateIdSelect.clearErrors();
                    templateIdSelectHelper.setValue(null);
                    descriptionTextArea.val("").clearErrors();
                    positionOrderInput.val("").clearErrors();
                    templatePackageLinkKey.val(defaultTemplatePackageLinkKey);
                }

                // clear event banner messages and reset grid selection to first row
                function cancelCorrespondenceClicked() {
                    eventBanner.removeAllMessages();

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }
            }

        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);